import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DoorOpen } from "lucide-react";
import { toast } from "sonner";
import { MovementBadge } from "./PortailExtras";

// Parents / élèves : historique des entrées et sorties de l'établissement
export default function EntreesSortiesPage() {
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/gate/my")
      .then(({ data }) => setRows(data))
      .catch(e => toast.error(e.response?.data?.detail || "Erreur de chargement"))
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div className="space-y-6" data-testid="entrees-sorties-page">
      <div>
        <div className="chip mb-2"><DoorOpen className="h-3 w-3" /><span>ENTRÉES & SORTIES</span></div>
        <h1 className="font-heading font-extrabold text-3xl text-[#1E3A8A]">Entrées & sorties de l&apos;école</h1>
        <p className="text-slate-500 mt-1">Chaque passage de la carte scolaire au portail est enregistré et vous est notifié.</p>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="px-4 py-2 text-left">Date</th>
              <th className="px-4 py-2 text-left">Heure</th>
              <th className="px-4 py-2 text-left">Élève</th>
              <th className="px-4 py-2 text-left">Classe</th>
              <th className="px-4 py-2 text-left">Mouvement</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(m => (
              <tr key={m.id} className={`border-t border-slate-100 ${m.flag === "sortie_anticipee_non_autorisee" ? "bg-red-50" : ""}`} data-testid={`my-movement-${m.id}`}>
                <td className="px-4 py-2 font-mono text-xs">{m.date}</td>
                <td className="px-4 py-2 font-mono text-xs font-bold text-[#1E3A8A]">
                  {new Date(m.timestamp).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}
                </td>
                <td className="px-4 py-2 font-semibold">{m.student_name}</td>
                <td className="px-4 py-2 text-slate-600">{m.class_name}</td>
                <td className="px-4 py-2"><MovementBadge m={m} /></td>
              </tr>
            ))}
            {loaded && rows.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-400">Aucun mouvement enregistré pour le moment.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
